var map = {
	"./doc.png": 41426,
	"./docx.png": 73760,
	"./others.png": 71979,
	"./pdf.png": 38334,
	"./ppt.png": 75232,
	"./pptx.png": 59946,
	"./sp.png": 49415,
	"./txt.png": 49708,
	"./xls.png": 5523,
	"./xlsx.png": 68387,
	"./yy.png": 14488,
	"./zip.png": 76161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68229;